import { Model } from "@tailflow/laravel-orion/lib/model";

export class ActivityLog extends Model {
    $resource(): string {
        return "activity-logs";
    }
}
